import React from 'react';
import PropTypes from 'prop-types';
import MenuIcon from '@material-ui/icons/Menu';
import Button from 'Components/UI/Button';
import { useNavigationContext } from 'Components/ComponentLibrary/Organisms/NavigationWithContext/NavigationContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import HamburgerMenuWithSiteNavigation from 'Components/ComponentLibrary/Molecules/HamburgerMenuWithSiteNavigation';
import HeaderBar from 'Components/ComponentLibrary/Molecules/HeaderBar';


const WizardStandardHeader = ({
  title,
  navigationExists,
  showMobileSideNavigationMenu,
  transparentBackground,
  onClose,
}) => {
  const isMobile = useMobileLayout();
  const {
    open, setOpen, navigationHeaderLeft, navigationHeaderRight,
  } = useNavigationContext();

  const toggleDrawer = () => {
    setOpen(!open);
  };

  let leftContent = null;
  if (navigationHeaderLeft) {
    leftContent = navigationHeaderLeft;
  } else if (navigationExists) {
    leftContent = (
      <Button
        onClick={toggleDrawer}
        test="wizard-header-menu-button"
        color={transparentBackground ? 'white' : 'primary'}
        variant={'icon'}
      >
        <MenuIcon />
      </Button>
    );
  } else if (showMobileSideNavigationMenu) {
    leftContent = <HamburgerMenuWithSiteNavigation color={transparentBackground ? 'white' : 'primary'} />;
  }

  return (
    <HeaderBar
      transparentBackground={transparentBackground}
      title={title}
      left={isMobile ? leftContent : null}
      right={navigationHeaderRight || null}
      TitleProps={{
        test: 'wizard-module-name',
      }}
      onClose={onClose}
    />
  );
};

WizardStandardHeader.defaultProps = {
  title: undefined,
  navigationExists: false,
  showMobileSideNavigationMenu: false,
  transparentBackground: false,
  onClose: undefined,
};

WizardStandardHeader.propTypes = {
  title: PropTypes.string,
  navigationExists: PropTypes.bool,
  showMobileSideNavigationMenu: PropTypes.bool,
  transparentBackground: PropTypes.bool,
  onClose: PropTypes.func,
};

export default WizardStandardHeader;
